import { refundRequestService } from "../services/refundRequests/index1";

const namespace = "refundRequests";
const initialState = {
  list: [],
  loading: {
    fetchList: false,
    update: false,
  },
  total: 0,
};

export const fetchList = (params) => ({
  type: `${namespace}/fetchList`,
  payload: params,
});

export const update = (id) => ({
  type: `${namespace}/update`,
  payload: id,
});

export default {
  namespace,
  state: initialState,
  effects: {
    *update({ payload }, { call, put }) {
      yield put({ type: "startLoading", loadingType: "update" });
      try {
        const response = yield call(refundRequestService.update, payload);
        yield put({ type: "updateList", payload:response.data });
        yield put({ type: "stopLoading", loadingType: "update" });
        
      } catch (error) {
        console.error("Error updating refund request:", error);
      }
    },

    *fetchList({ payload }, { call, put }) {
      yield put({ type: "startLoading", loadingType: "fetchList" });
      try {
        const response = yield call(refundRequestService.fetchList, payload);
        yield put({ type: "setList", list: response.data.list });
        yield put({ type: "setTotal", total: response.data.total});
        yield put({ type: "stopLoading", loadingType: "fetchList" });
      } catch (error) {
        console.error("Error fetching refund requests:", error);
      }
    },
  },
  reducers: {
    updateList(state, { payload }) {
    const updatedList = state.list.filter((item) => item.id !== payload.id);
      return { ...state, list: updatedList };
    },
    setList(state, { list }) {
      return { ...state, list };
    },
    setTotal(state, { total }) {
      return { ...state, total };
    },
    startLoading(state, { loadingType }) {
      return { ...state, loading: { ...state.loading, [loadingType]: true } };
    },
    stopLoading(state, { loadingType }) {
      return { ...state, loading: { ...state.loading, [loadingType]: false } };
    },
  },
};